module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/isolated-forgot-pwd/isolated-forgot-pwd.component.css
// module id = ./src/app/Screens/isolated-forgot-pwd/isolated-forgot-pwd.component.css
// module chunks = main